module.exports = __webpack_public_path__ + "static/media/folder.c95ea0ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/folder.svg
// module id = 648
// module chunks = 0